module.exports = __webpack_public_path__ + "img/ba.1d77d260.png";